import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getWorkspaceConfiguration } from 'services/workspaces/v2'
import { WorkspaceConfigurationQueryKeys } from 'services/workspaces/v2/queryKeys'
import { GetWorkspaceConfigurationResponse } from 'services/workspaces/v2/types'

export const useGetWorkspaceConfiguration = (
  workspaceId: string,
  options?: Omit<UseQueryOptions<GetWorkspaceConfigurationResponse>, 'queryKey'>
) => {
  return useQuery({
    queryKey: WorkspaceConfigurationQueryKeys.GetWorkspaceConfiguration(workspaceId),
    queryFn: ({ signal }) => getWorkspaceConfiguration(workspaceId, { signal }),
    ...options
  })
}
